import React from 'react';

import TranslationUtils from 'Utils/TranslationUtils';

import { Helmet } from 'react-helmet';
import c from '../../../Components/AuthLayout/authContent.module.less';

function YellowPage() {
  return (
    <>
      <Helmet>
        <title>{gettext('Pending Vetting')}</title>
      </Helmet>
      <h1 test-id="page-title" className={c.title}>
        {TranslationUtils.getText('YELLOW_PAGE_TITLE')}
      </h1>
      <p className={c.text}>
        {TranslationUtils.getText('YELLOW_PAGE_PART_1')}
        {TranslationUtils.getText('YELLOW_PAGE_PART_2')}
      </p>
    </>
  );
}

export default YellowPage;
